import { mountComponentTag } from '@/mounter'

import DotcomIcon from './Icon'

mountComponentTag('dotcom-icon', DotcomIcon)
